/**
 * Remove the focus capability of an element
 *
 * @param element - The element
 */
export function removeElementFocusability(element) {
    element?.setAttribute('tabindex', '-1');
}
/**
 * Remove the focus capability of the map's controls
 *
 * @param container - Map container element
 */
export function removeMapControlsFocusability(container) {
    container
        ?.querySelectorAll('.mapboxgl-control-container a')
        .forEach((link) => {
        removeElementFocusability(link);
    });
}
